import React from 'react';
import {Grid} from "@mui/material";
import Banner from '../components/ncp2026/Banner';
import Steps from '../components/ncp2026/Steps';
import Prize from '../components/ncp2026/Prize';

const KozelNcp2026: React.FC = () => {

    return (
        <>
            <Banner />
            <Steps />
            <Prize />
        </>
    );
}

export default KozelNcp2026;